<template>
  <form @submit.prevent="addFlow">
    <InputDash       
      label="REF"
      :isTextArea="false"
      value="Auto"
      :isDisabled="true"
    />
    <InputDash       
      label="Name"
      name="Name"
      placeholder="Name of the flow"
      :isTextArea="false"
      :isDisabled="false"
      v-model="name"
      :validation="!this.inValidFields.includes('name')"
    />
    <DynamicFlowList  
      label="Production Steps"
      name="Production Steps"
      @updateSteps="gotSteps"
    />
    <div class="buttons">
      <BaseButton color="tertiary" :key="1" type="button" size="modal-sm" @click.native="emitClose(true)">
        Cancel
      </BaseButton>
      <BaseButton color="primary" :key="2" type="submit" size="modal-sm">
        Add
      </BaseButton>
    </div>
  </form>
</template>

<script>
import BaseButton from "@/components/base/Button.vue";
import InputDash from "@/components/base/InputDash.vue";
import DynamicFlowList from "@/components/base/DynamicFlowList.vue";


export default {
  components: {
    InputDash,
    BaseButton,
    DynamicFlowList
  },
  props: {
    title: String,
  },
  data(){
    return {
      name : "",
      steps : [],
      inValidFields: [],
    }
  },
  methods: {
    addFlow() {

    var that = this

      this.inValidFields = []
      if(this.name == "") {
        this.inValidFields.push("name")
      }

      if(this.steps.length <= 0) {
        this.inValidFields.push("steps")
      }
      
      // for(var i = 0; i < this.steps.length; i++) {
      //   this.steps[i].order = i+1
      // }
      let nsteps=[]
      for(var i = 0; i < this.steps.length; i++) {
        if(this.steps[i].id){
          nsteps.push(this.steps[i])
          this.steps[i].order = i+1
        }
      }
      if(this.inValidFields.length == 0) {
        this.$http.post(this.$endpoint + 'management/productionFlow/flow', {
          "name": this.name,
          "steps": nsteps
        })
        .then(function (response) {
          that.$emit('closeModal', true);
          that.$swal(
            'Production flow added!',
            `Your flow has been successfully added.`,
            'success'
          );
        })
        .catch(function (error) {
          that.$swal(
            'Oops that went wrong?',
            `Please contact the admin with the following info: ${ error }`,
            'error'
          );
        });
      } else if(this.inValidFields.indexOf("steps") > -1) {
          that.$swal(
            "That doesn't seem right?",
            `You didn't add any steps to this flow?! A flow needs at least 1 step.`,
            'error'
          );
      }
    },
    emitClose(isClicked) {
      this.$emit('closeModal', isClicked);
    },
    gotSteps(newSteps) {
      this.steps = newSteps
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";

.steps-bullets{
  margin-top: 40px;
}

</style>
